export default (context, inject) => {
  const resetAuthtoken = () => {
    const $cookies = context?.$cookies;
    let domain = String(window.location.hostname || "").replace('https://', '').split('/')?.[0];

    if ($cookies) {
      $cookies.set('authToken', '', {
        path: "/",
        domain: domain,
        expires: new Date(0),
      });
      $cookies.set('authToken', '', {
        path: "/",
        domain: `.${domain}`,
        expires: new Date(0),
      });
    } else {
      document.cookie = "authToken=; expires=Thu, 01 Jan 1970 00:00:01 UTC; path=/; domain=" + domain;
      document.cookie = "authToken=; expires=Thu, 01 Jan 1970 00:00:01 UTC; path=/; domain=." + domain;
    }

    return true;
  }
  inject('resetAuthtoken', resetAuthtoken)
}
